import React from 'react'
import _ from 'lodash'

import Spinner from '~/components/Spinner'

import SelectPlan from './SelectPlan'
import CreateAccount from './CreateAccount'
import Billing from './Billing'
import ThankYou from './ThankYou'
import popup from '../../popup'
import userStore from '~/redux/user/store'
import {
  getSubscriptionPlans,
  getInvisiblePlans,
  getDiscountPrice
} from "~/redux/user/subscription";
import { trackGA } from './ga'
import { trackEvent } from '~/tools/analytics/cleverTap'
import getCountryCode from '~/tools/userEnvironment/getCountryCode'
import Verify from '../../views/Purchase/verify'
import './style.css'
import connect from "~/tools/connect";

class SubscriptionView extends React.Component {
  constructor(props) {
    super(props)
    this.argsPresent = props.args && (props.args.selected !== undefined);
    this.subscriptionInitiated = false
    var user = userStore.getState().user

    this.state = props.state || {
      'current': (!this.argsPresent ? 'selectPlan' : user ? 'billing' : 'createAccount'),
      'paymentHandler': null
    }
    this.trackCT = this.trackCT.bind(this)
  }

  componentDidMount() {
    if (this.plansLoaded)
      return
    if(!window.sessionStorage.getItem('plans')){  
      getSubscriptionPlans().then( plans => {
        this.setState({ 'plans': plans, 'selectedPlan': this.argsPresent ?  this.findIndex(plans, (plan) => plan.id === this.props.args.selected) : 0 })
      })
    } else {
      getInvisiblePlans().then( plans => {
        this.setState({ 'plans': plans, 'selectedPlan': this.argsPresent ?  this.findIndex(plans, (plan) => plan.id === this.props.args.selected) : 0 })
      })
    }
    getCountryCode().then(country => {
      var providers = window.settings.paymentProviders
      for (var k in providers) {
        if (_.includes(providers[k].country, country)) {
          return this.setState({ paymentHandler: k })
        }
      }
      for (k in providers) {
        if (_.includes(providers[k].country, 'ROW')) {
          return this.setState({ paymentHandler: k })
        }
      }
      return this.setState({ paymentHandler: 'stripe' })
    })
    this.plansLoaded = true
  }

  findIndex(arr, fn) {
    return arr.reduce((carry, item, idx) => {
        if(fn(item, idx)) {
            return idx;
        }
        return carry;
    } , -1);
  }

  canAccess(state) {
    return (
      (state === 'selectPlan') ||
      (state === 'createAccount' && this.isComplete('selectPlan')) ||
      (state === 'billing' && this.isComplete('createAccount') && this.isComplete('selectPlan'))
    )
  }

  isComplete(state) {
    return (
      (state === 'selectPlan' && typeof this.state.selectedPlan === 'number') ||
      (state === 'createAccount' && this.state.user) ||
      (state === 'billing' && false)
    )
  }

  clickChangeToState(state) {
    if (!this.canAccess(state)) return false
    this.setState({ current: state })
    return true
  }

  componentDidUpdate(prevProps, prevState) {
    this.state.plans && trackGA(this, prevProps, prevState)
    if(prevState.selectedPlan !== this.state.selectedPlan){ this.subscriptionInitiated = false }
    if(this.state.paymentHandler){ this.trackCT(prevProps, prevState) }
    if (this.state.plans) {
      if(prevState.current !== 'billing' && this.state.current === 'billing'){
        this.getActualPrice();
      } else if(this.state.current === 'billing' && this.state.current === 'billing' && !this.state.firstPayment){
        this.getActualPrice()
      }
    }
  }

  render() {
    if (!this.state.plans)
      return (<div className="loading centered"><Spinner/></div>)

    if (this.state.current === 'thankyou')
        return (<div className="subscription centered">{ this.thankYouScreen() }</div>)

    var left = ( - 100 * [
      'selectPlan', 'createAccount', 'billing'
    ].indexOf(this.state.current)) + '%'

    var titleMap = {
      'selectPlan': ['Select a Plan', 'Plan Selected'],
      'createAccount': ['Create an Account', 'Account Created'],
      'billing': ['Add Billing & Subscribe', 'Subscribed!']
    }

    return (
      <div className="subscription-view centered">
        <div className="mobile-title">
            <div className="page"><strong>{ Object.keys(titleMap).indexOf(this.state.current) + 1 }</strong> of 3</div>
            { titleMap[this.state.current][0] }
        </div>

        { this.state.current !== 'selectPlan' &&
          <div
            className="back-button"
            onClick={ _ => this.setState({
              current: (this.state.current === 'createAccount' ? 'selectPlan' : 'createAccount')
            }) } >
            <i className="ion-android-arrow-back" />
          </div>
        }
        <div className="progress">
          { _.map(titleMap, (v, k) => (
            <div
              key={k}
              className={
                this.state.current === k ? 'red' :
                this.isComplete(k) ? 'ticked' : ''
              }
              onClick={ _ => this.clickChangeToState(k) } >
               { v[(this.isComplete(k) && this.state.current !== k) ? 1 : 0] }
               <div className="bar site-color site-color-after"></div>
            </div>
          ) ) }
        </div>
        <div className="screen">
          <div className="slider" style={ { marginLeft: left } }>
            <div className={ 'slide' + ( this.state.current !== 'selectPlan' ? ' hidden' : '' ) } >
              { this.selectPlanEl() }
            </div>
            <div className={ 'slide' + ( this.state.current !== 'createAccount' ? ' hidden' : '' ) } >
              { this.createAccountEl() }
            </div>
            <div className={ 'slide' + ( this.state.current !== 'billing' ? ' hidden' : '' ) } >
              {(this.state.current === 'billing') && this.billingEl() }
            </div>
          </div>
        </div>
      </div>
    )
  }

  trackCT(prevProps, prevState){
    if(typeof this.state.selectedPlan === 'number' && !this.subscriptionInitiated){
      const plan = this.state.plans[this.state.selectedPlan]
      const planDetails = plan.planDetails[0]
      var initiateSubscriptionEventData = {
        paymentHandler: this.state.paymentHandler,
        country: planDetails.countryCode,
        currency: planDetails.recurringPaymentCurrencyCode,
        amount: planDetails.strikeThroughPrice ? planDetails.strikeThroughPrice : planDetails.recurringPaymentAmount,
        discountAmount: planDetails.recurringPaymentAmount,
        paymentPlan: plan.name
      }
      trackEvent('Subscription Initiated', initiateSubscriptionEventData)
      this.subscriptionInitiated = true
    }
  }

  selectPlanEl() {
    return (
      <SelectPlan
        isCurrent={ this.state.current === 'selectPlan' }
        plans={this.state.plans}
        selected={ this.state.selectedPlan }
        selectPlan={ i => {
          if (this.state.selectedPlan === i)
            this.setState({ current: 'createAccount'})
          else
            this.setState({
              selectedPlan: i,
              editingOfferCode: false,
              offerCode: null })
        } } />
    )
  }

  createAccountEl() {
    return (
      <CreateAccount
        plan={ this.state.plans[this.state.selectedPlan] }
        user={ this.state.user }
        offerCode={ this.state.offerCode }
        editingOfferCode={ this.state.editingOfferCode }

        addCode={ c => this.setState({ offerCode: c, editingOfferCode: false })  }
        removeCode={ c => this.setState({ offerCode: null, editingOfferCode: false }) }
        editOfferCode={ c => this.setState({ editingOfferCode: c }) }

        editPlan={ s => { this.setState({ current: 'selectPlan' }) } }
        continue={ c => { 
          // trackEvent('Signed Up', {registrationType: 'Native'})
          this.setState({ current: 'billing' }) 
        } }
        goToLogin={ _ => popup.login() }/>
    )
  }

  billingEl() {
    this.storePlanDetails()
    if (this.state.user && this.state.user.billingInfo && this.state.user.billingInfo.stripeToken){
      return (
        <Verify 
          plan={this.state.plans[this.state.selectedPlan]}
          firstPayment={this.state.firstPayment}
          edit={() => this.setState({user : {...this.state.user, billingInfo: {}},updateCard: true})}
          offerCode={this.state.offerCode}
          success={data => this.setState({ subscriptionData: data, current: 'thankyou' })}
          subscription={true}
          user={this.state.user}
        />
      )
    }
   
    return (
      <Billing
        firstPayment={this.state.firstPayment}
        plan={ this.state.plans[this.state.selectedPlan] }
        updateCard={this.state.updateCard}
        offerCode={ this.state.offerCode }
        editPlan={ _ =>this.setState({ current: 'selectPlan' }) }
        user={this.state.user}
        editPromo={ _ => this.setState({ current: 'createAccount', editingOfferCode: true }) }
        success={ data => this.setState({ subscriptionData: data, current: 'thankyou'}) }
        />
    )
  }

  getActualPrice = () => {
    const data = {
      userId: this.state.user.userId,
      planId: this.state.plans[this.state.selectedPlan].id,
      offerCode: this.state.offerCode && this.state.offerCode.code
    }
    getDiscountPrice(data).then(res => {
      this.setState({ firstPayment: res.data })
    })
  }

  thankYouScreen() {
    return (
      <ThankYou
        plan={ this.state.plans[this.state.selectedPlan] }
        user={ this.state.user }
        firstPayment={this.state.firstPayment}
        subscriptionData={ this.state.subscriptionData } />
    )
  }
  storePlanDetails(){
   const plan = this.state.plans[this.state.selectedPlan]
   localStorage.setItem('planDetails', JSON.stringify(plan))
  }
}

connect(SubscriptionView, (state) => ({ user: state.user }), userStore)


export default SubscriptionView;